import { Injectable } from '@angular/core';
import { IFactoryRepository } from './factory.interface';

/**
 * Registers a model's `getPath()`/`new()` factory for BaseRepository to resolve
 * by name. No models are registered yet — register the first real ERP resource
 * here once the API exposes one for the `app` persona.
 */
@Injectable({ providedIn: 'root' })
export class FactoryRepository {
  private readonly models: IFactoryRepository = {};

  public getModel(modelName: string): any {
    return this.models[modelName];
  }
}
